module.exports = __webpack_public_path__ + "static/media/shia-max.9816ae14.mp3";